var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('qutab',{attrs:{"titleName":_vm.title}}),_c('div',{staticClass:"training"},[_c('TrainTest',{attrs:{"title":_vm.title2,"name":'pxks'}})],1),_c('div',{staticClass:"query"},[_c('tab',{attrs:{"titleName":_vm.listTitle,"list":_vm.Tablist,"id":'jpkc'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }